module.exports = __webpack_public_path__ + "img/extended.6871de72.png";